import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcHandle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 4.5H15.75",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 4.5H15.75",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 4.5H15.75",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 4.5H15.75",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 9H15.75",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 9H15.75",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 9H15.75",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 9H15.75",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 13.5H15.75",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 13.5H15.75",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 13.5H15.75",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 13.5H15.75",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIcHandle;
